export default __webpack_public_path__ + "static/media/Instagram.332014f2.svg";